
import { Column } from "primereact/column";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import campaignsAPI from "../../../../services/campaigns";
import MeaButton from "../../../../components/MeaButton";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import membersAPI from "../../../../services/members";
import { useNavigate } from "react-router-dom";
import schoolsAPI from "../../../../services/schools";
import { replaceMailPreviewCidImages } from "../../../../utils/mailPreview";

const MailsListComponent = forwardRef((props, ref) => {
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  //
  const schoolId = props?.schoolId;
  const trainingId = props?.trainingId;
  const campaignId = props?.campaignId;
  //
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [schoolAvatar, setSchoolAvatar] = useState("");
  const accessToken = "";
  //
  const [mailBody, setMailBody] = useState("");
  const previewBody = replaceMailPreviewCidImages(mailBody, schoolAvatar);
  //
  const [previewDialogVisible, setPreviewDialogVisible] = useState(false);
  const showPreviewDialog = () => {
    setPreviewDialogVisible(true);
  }
  const hidePreviewDialog = () => {
    setPreviewDialogVisible(false);
  }
  useEffect(() => {
    if (!schoolId) {
      setSchoolAvatar("");
      return;
    }
    schoolsAPI.GetOneSchool(schoolId).then((data) => {
      setSchoolAvatar(data?.data?.avatar || "");
    });
  }, [schoolId]);
  //
  const queryList = campaignsAPI.GetEmails(
    schoolId,
    trainingId,
    accessToken,
    campaignId,
    page,
    pageSize
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  const showProfile = (e, item) => {
    e.preventDefault();
    const email = item?.to;
    membersAPI.GetMemberByEmail(schoolId, email).then((data) => {
      console.log(data?.data[0]?.id);
      if (data?.data?.length > 0) {
        navigate(`/school/${schoolId}/admin/members/${data?.data[0]?.id}`);
      }
    });
  }
  //
  return (
    <>
      <Dialog
        visible={previewDialogVisible}
        onHide={hidePreviewDialog}
        maximizable
        modal header="Aperçu de l'email"
        footer={<Button label="Fermer" icon="pi pi-times" onClick={hidePreviewDialog} />}
        contentStyle={{ backgroundColor: 'var(--mea-background-color)' }}
      >
        <div className="flex flex-column p-3 mt-3 h-full" style={{ backgroundColor: 'white' }}>
          <div className="flex-grow-1" >
            {!currentMembership?.is_owner && (
            <div dangerouslySetInnerHTML={{ __html: previewBody.replace(/<a\s+href=["'][^"']*["'][^>]*>/gi, '<a href="#" onclick="return false;">') }}></div>
            )}
            {currentMembership?.is_owner && (
            <div dangerouslySetInnerHTML={{ __html: previewBody }}></div>
            )}
          </div>
        </div>
      </Dialog >
      <MeaDataTable
        query={queryList}
        serviceAPI={campaignsAPI}
        names={{ pagination: "email", singular: "email", plural: "emails" }}
        showDeleteButton={false}
        //showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
        schoolId={schoolId}
        trainingId={trainingId}
      >

        <Column
          field="to"
          header="Adresse e-mail"
          style={{ width: '25%' }}
        />
        <Column field="status" header="Statut" body={(item) => (
          <span>
            {(() => {
              switch (item.status) {
                case "SENT":
                  return <><i className="pi pi-check-circle" style={{ color: "green" }}></i> Envoyé</>;
                case "FAILED":
                  return <><i className="pi pi-times-circle" style={{ color: "red" }}></i> Échoué</>;
                case "CANCELLED":
                  return <><i className="pi pi-times-circle" style={{ color: "red" }}></i> Annulé</>;
                case "DRAFT":
                  return <><i className="pi pi-pencil" style={{ color: "blue" }}></i> Brouillon</>;
                case "PENDING":
                  return <><i className="pi pi-clock" style={{ color: "orange" }}></i> En attente</>;
                case "SUBMITTED":
                  return <><i className="pi pi-send" style={{ color: "purple" }}></i> Envoyé</>;
                default:
                  return <><i className="pi pi-question-circle" style={{ color: "gray" }}></i> Inconnu</>;
              }
            })()}
          </span>
        )} />

        <Column field="last_reaction_at" header="Dernière réaction Le" body={(item) => (
          <span>{item.last_reaction_at ? <><i className="pi pi-check-circle" style={{ color: "green" }}></i> {ToFormatedDateForEvents(new Date(item.last_reaction_at), false)}</> : "-"}</span>
        )} />
        <Column field="error" header="Aperçu" body={(item) => (
          <>
            <MeaButton
              icon="pi pi-eye"
              rounded
              text
              style={{ padding: "0", height: "1.5rem" }}
              onClick={() => {
                setMailBody(item.body);
                showPreviewDialog();
              }}
            //permission={PERMISSION_TRAINING_CAMPAIGN_MAILS.GET}
            />
          </>
        )} />
        <Column field="email" header="Profil" body={(item) => (
          <>
            <MeaButton
              icon="pi pi-user"
              rounded
              text
              style={{ padding: "0", height: "1.5rem" }}
              onClick={(e) => showProfile(e, item)}
            //permission={PERMISSION_TRAINING_CAMPAIGN_MAILS.GET}
            />
          </>
        )} />

      </MeaDataTable>
    </>
  );
});

export default MailsListComponent;
